<template>
  <div>
    <el-dialog
      title="vip充值"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <!-- vip充值 -->
      <div class="vipBox">
        <div
          class="itemBox"
          @click="chooseVip(item, index)"
          :class="{ bgc: nowIndex == index }"
          v-for="(item, index) in vipList"
          :key="index"
        >
          <!-- 头部标题 -->
          <div class="headBox" :class="{ textColor: nowIndex == index }">
            {{ item.title }}
          </div>
          <!-- 介绍文字 -->
          <div class="introText" v-html="item.content"></div>
          <!-- 金额 -->
          <div class="priceBox" :class="{ priceColor: nowIndex == index }">
            <span style="color: #C68C30;font-size: 16px;text-shadow: none;"
              >￥</span
            >
            {{ item.costAmount }}
          </div>
          <!-- 底部角标 -->
          <img
            v-if="nowIndex == index"
            class="floatBottom"
            src="../../src/assets/icon/choose.png"
          />
        </div>
      </div>
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <div class="payBtn" @click="payBtn()">
          购买
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getChargeInfo,
  creatOrder,
  getPayData,
  updatePayStatus,
  updataVip
} from "@/api/index"; //接口
export default {
  data() {
    return {
      dialogVisible: false, //是否显示弹窗
      bType: 100, //查询vip的参数
      vipList: [], //vip数组
      nowIndex: 0, //当前选中的索引
      clId: "", //当前的费用id
      remark: "生成vip充值订单",
      OrderID: "" //付款单号
    };
  },
  created() {
    setTimeout(() => {
      console.log("打印地址", this.$route.meta);
      if (this.$route.meta && !this.$route.meta.topNoShow) {
        this.getChargeInfo();
      }
    }, 300);
  },
  methods: {
    handleClose(done) {
      done();
    },
    //获取vip接口
    getChargeInfo() {
      getChargeInfo(this.bType).then(res => {
        if (res) {
          this.vipList = res.data;
          if (this.vipList.length > 0) {
            this.clId = this.vipList[0].clId;
          }
        }
      });
    },
    //选择vip
    chooseVip(obj, i) {
      console.log("打印当前的vip", obj);
      this.nowIndex = i;
      this.clId = obj.clId;
    },
    //购买
    payBtn() {
      let obj = {
        clId: this.clId,
        remark: this.remark
      };
      //创建订单 生成订单号
      creatOrder(obj).then(res => {
        console.log("生成订单号", res);
        if (res.code === 0) {
          this.OrderID = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.vipBox {
  min-height: 300px;
  height: auto;
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.vipBox .itemBox {
  width: 32%;
  height: 300px;
  box-shadow: 5px 5px 6px #ccc;
  margin-bottom: 10px;
  background-color: #b0bad3;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  position: relative;
}
.vipBox .itemBox .headBox {
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  text-shadow: 4px 3px 0px #ccc;
  height: 40px;
}
.bgc {
  background-color: #d8c59d !important;
  background-image: url(../../src/assets/icon/vip.png);
  background-repeat: no-repeat;
  background-position: center;
}
.textColor {
  color: #c68c30 !important;
  text-shadow: 4px 3px 3px #fff !important;
}
.priceColor {
  color: #c68c30 !important;
  text-shadow: 2px 2px 2px #fff !important;
}
.vipBox .itemBox .introText {
  flex: 1;
  overflow: hidden;
  color: #fff;
}
.vipBox .itemBox .priceBox {
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  text-shadow: 2px 2px 2px #c68c30;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-footer .payBtn {
  height: 40px;
  line-height: 40px;
  border-radius: 2500px;
  width: 33%;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background-image: linear-gradient(90deg, #ffca0b, #ffa220) !important;
}
.floatBottom {
  position: absolute;
  bottom: -5px;
  right: -5px;
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/vipRecharge.vue